import { StyleSheet, Text, View } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  line: {
    borderTop: '2px solid black',
    width: 150,
    paddingTop: 5,
    fontSize: 12,
    fontWeight: 'bold',
  },
})
interface Props {
  underlineText: string
}
const SignatureLine = ({ underlineText }: Props) => {
  return (
    <>
      <View style={styles.line}>
        <Text style={{ fontSize: 8, textAlign: 'center' }}>
          {underlineText}
        </Text>
      </View>
    </>
  )
}
export default SignatureLine
